export default __webpack_public_path__ + "static/media/milestone 4600.3cf068e2.svg";